export var AniEventTypes = {
    API_KEY: 'apiKey'
};
